export default "__VITE_ASSET__Ij2J7HOb__"